module.exports = __webpack_public_path__ + "img/product_86.4b9883f.webp";